import React, { useState, useEffect } from "react";
import { producaov2 as api } from "../../../../../services/apis";
import { Button, Form, Input, Divider } from "semantic-ui-react";
import * as yup from "yup";

import {
  Container,
  Content,
  Title,
  Field,
  Label,
  Colaborador,
  ListaColaboradores,
  InputFile,
} from "./styles";

import swal from "sweetalert";
import { Link, withRouter } from "react-router-dom";
import AdminMenu from "../../../../../components/Admin/MenuDetalhes/AdminMenu";
import { isAuthAdmin } from "../../../../../services/auth";
import { retira_acentos } from "../../../../../utils/Utils";

const AtualizaColaborador = (props) => {
  const [colaborador, setColaborador] = useState({
    nome: "",
    fk_cargo: "",
    descricao: "",
    linkedin: "",
    instagram: "",
    site: "",
    url_image: "",
  });
  const [id, setId] = useState(null);
  const [imagem, setImagem] = useState(null);
  const [nameImagem, setNameImagem] = useState(null);

  useEffect(() => {
    loadAuth();
  }, []);

  const loadAuth = async () => {
    const auth = await isAuthAdmin();

    if (!auth) {
      localStorage.setItem("redirect", `/admin/`);
      window.location.href = "/login";
      return null;
    }
  };

  const uploadImagem = async () => {
    if (!imagem) return;

    const payload = new FormData();
    payload.append("file", imagem);
    payload.append("path", "lives/colaboradores");
    payload.append("nome", nameImagem);

    return api
      .post("/upload", payload)
      .then((res) => {
        const url = res.data.url;
        if (url) return true;
      })
      .catch((err) => {
        console.error(err);
        return false;
      });
  };

  const clearNomeCapa = (nome) => {
    let cleanedName = nome.replace(/  */g, "-");
    cleanedName = cleanedName.replace(/\+ */g, "");
    cleanedName = cleanedName.replace(/\(/g, "");
    cleanedName = cleanedName.replace(/\)/g, "");
    cleanedName = cleanedName.replace(/.png/, "");
    cleanedName = cleanedName.replace(/.jpg/, "");
    cleanedName = cleanedName.replace(/.jpeg/, "");
    cleanedName = cleanedName.replace(/.jfif/, "");

    cleanedName = cleanedName.replace(/\./g, "");

    cleanedName = cleanedName.toLowerCase();
    cleanedName = retira_acentos(cleanedName);

    return cleanedName;
  };

  useEffect(() => {
    if (!imagem) return;

    if (imagem.type !== "image/jpg" && imagem.type !== "image/jpeg") {
      swal(
        "As imagens devem sempre ser .jpg - Essa imagem é do tipo " +
          imagem.type
      );
      return;
    }

    const nomeCapa = imagem.name;

    if (nomeCapa.indexOf(".jfif") > -1 || nomeCapa.indexOf(".jpeg") > -1) {
      swal("As imagens devem sempre ser .jpg ");
      return;
    }

    const cleanName = clearNomeCapa(nomeCapa);
    setNameImagem(cleanName);

    setColaborador({ ...colaborador, url_image: cleanName });
  }, [imagem]);

  const update = async () => {
    const colaboradorValidation = await yup.object().shape({
      nome: yup
        .string("Necessário que informe o nome")
        .required("Necessário que informe o nome"),
      fk_cargo: yup
        .string("Necessário que informe o cargo")
        .required("Necessário que informe o cargo"),
      linkedin: yup
        .string("Necessário que informe o linkedin")
        .required("Necessário que informe o linkedin"),
      url_image: yup
        .string("Necessário que informe se o site")
        .required("Necessário que informe o site"),
    });

    const confirmation = await uploadImagem();

    if (!confirmation) {
      swal("Erro no upload de imagem !");
      return;
    }

    try {
      await colaboradorValidation.validate(colaborador, { abortEarly: true });
      api
        .put(`/admin/webserie/colaboradores/${id}`, colaborador)
        .then(async (res) => {
          swal("Sucesso na atualização !");
        })
        .catch((err) => {
          swal("Não foi possível atualizar os dados", err, "").then((res) =>
            props.history.push("/admin/lives")
          );
        });
    } catch (err) {
      if (err instanceof yup.ValidationError) {
        swal("Erro!", `${err}`, "error");
        return;
      }
    }
  };

  useEffect(() => {
    const id = window.location.href.split("?")[1];
    if (!id || id === "") {
      window.location.href = "/admin/webserie-colaborador";
    }
    api
      .get(`/webserie/colaboradores/${id}`)
      .then((res) => {
        if (res.data.length <= 0) {
          window.location.href = "/admin/webserie-episodio";
        }

        const data = {
          nome: res.data[0]?.nome,
          fk_cargo: "",
          descricao: res.data[0]?.descricao,
          linkedin: res.data[0]?.linkedin,
          instagram: res.data[0]?.instagram,
          site: res.data[0]?.site,
          url_image: res.data[0]?.url_image,
        };

        if (res.data[0]?.cargo.cargo === "convidado") {
          setColaborador({
            ...data,
            fk_cargo: 2,
          });
        } else {
          setColaborador({
            ...data,
            fk_cargo: 1,
          });
        }

        setId(id);
      })
      .catch((err) =>
        swal(`Erro: ${err.message}`).then(
          () => (window.location.href = "/admin/webserie-episodio")
        )
      );
  }, []);

  return (
    <>
      <Container>
        <AdminMenu />
        <Content>
          <Title>Criar Colaborador</Title>

          <Form>
            <Form.Group widths="equal">
              <Form.Field
                control={Input}
                value={colaborador.nome}
                label="Nome do Colaborador"
                placeholder="Nome do Colaborador"
                onChange={(e) => {
                  setColaborador({ ...colaborador, nome: e.target.value });
                }}
              />
            </Form.Group>
            <Form.Group widths="equal">
              <textarea
                control={Input}
                type={"textarea"}
                value={colaborador.descricao}
                label="Descrição do Colaborador"
                placeholder="Descrição do Colaborador"
                onChange={(e) => {
                  setColaborador({ ...colaborador, descricao: e.target.value });
                }}
              />
            </Form.Group>

            <Form.Group widths="equal">
              <Form.Field
                control={Input}
                value={colaborador.linkedin}
                label="Linkedin do Colaborador"
                placeholder="Linkedin do Colaborador"
                onChange={(e) => {
                  setColaborador({ ...colaborador, linkedin: e.target.value });
                }}
              />
            </Form.Group>
            <Form.Group widths="equal">
              <Form.Field
                value={colaborador.instagram}
                control={Input}
                label="Instagram do Colaborador"
                placeholder="Instagram do Colaborador"
                onChange={(e) => {
                  setColaborador({ ...colaborador, instagram: e.target.value });
                }}
              />
            </Form.Group>
            <Form.Group widths="equal">
              <Form.Field
                control={Input}
                value={colaborador.site}
                label="Site do Colaborador"
                placeholder="Site do Colaborador"
                onChange={(e) => {
                  setColaborador({ ...colaborador, site: e.target.value });
                }}
              />
            </Form.Group>

            <Form.Group widths="equal">
              <Field>
                <Label>Imagem Colaborador</Label>
                <InputFile
                  name="imagem"
                  type="file"
                  onChange={(e) => {
                    const capa = e.target.files[0];
                    setImagem(capa);
                  }}
                />
                <div></div>
                <div>
                  <br />
                </div>
              </Field>
            </Form.Group>
            <Form.Group widths="equal">
              <Form.Field
                control={Input}
                label="URL da Imagem (Ao fazer o upload da imagem a URL irá aparecer aqui para conferir)"
                placeholder="URL Imagem"
                value={colaborador.url_image}
                readOnly={true}
              />
            </Form.Group>

            <Form.Group widths="equal">
              <Form.Field>
                <Label> Cargo </Label>

                <select
                  onChange={(e) =>
                    setColaborador({ ...colaborador, fk_cargo: e.target.value })
                  }
                  value={colaborador.fk_cargo}
                >
                  <option value={1}> Host</option>
                  <option value={2}> Convidado </option>
                </select>
              </Form.Field>
            </Form.Group>

            <Divider hidden />
            <Form.Group>
              <Form.Field
                control={Button}
                onClick={() => {
                  update();
                }}
              >
                Enviar
              </Form.Field>
              <Link to="/admin/webserie-colaborador">
                <Button color="secondary">Cancelar</Button>
              </Link>
            </Form.Group>
          </Form>
        </Content>
      </Container>
    </>
  );
};

export default withRouter(AtualizaColaborador);
